import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashPlayerComponent } from './smash-player/smash-player.component';
import { PlyrModule } from 'ngx-plyr';



@NgModule({
  declarations: [SmashPlayerComponent],
  imports: [
    CommonModule,
    PlyrModule, // Very Heavy to compile 
  ],
  exports: [
    SmashPlayerComponent
  ]
})
export class SmashPlayerModule { }
